import { FC } from "react";
import { Outlet } from "react-router-dom";

import { ConditionKey } from "config/conditions";
import NotFound from "containers/NotFound/NotFound";
import { useCondition } from "modules/hooks/useCondition";

export const createConditionalLayout = (conditions: ConditionKey[]) => {
  const ConditionalLayout: FC = () => {
    const userConditions = useCondition(conditions);
    const hasRequiredConditions = conditions.every(key => userConditions[key]);

    if (!hasRequiredConditions) {
      return <NotFound />;
    }

    return <Outlet />;
  };

  ConditionalLayout.displayName = `ConditionalLayout(${conditions.join(",")})`;

  return ConditionalLayout;
};
